'use client';

import { FixedContainer } from 'app/[lang]/[esite]/(core)/product/[product]/fixed-container';
import ContactDealerMobileDrawer from 'components/contact-dealer-mobile-drawer';
import SavedListButton from '../../saved-list-button/saved-list-button';
import { MyEquipmentList } from 'components/my-equipment/types';
import { SavedList } from 'services/savedLists/types';
import { ProductPriceAvailability } from 'services/priceAvailability/types';
import { LocationResponse } from 'services/location/types';

interface ContactDealerMobileActionsProps {
  userStoreLocationData: LocationResponse;
  part: ProductPriceAvailability;
  locale: string;
  isCustomerSupportEnabled?: boolean;
  isLoggedIn?: boolean;
  savedLists: SavedList[];
  userHasShoppingLists?: boolean;
  isCspUser?: boolean;
  isDealerUser?: boolean;
  isInstantAccessUser?: boolean;
  isAssociateEquipmentToSavedList: boolean;
  myEquipmentList: MyEquipmentList[];
  selectedEquipmentIndex: number;
  isError: boolean;
  isUpdatePDPCTAFeatureFlag?: boolean;
  isPartTypeSoftware?: boolean;
  isStickyCTAMobileFlag?: boolean;
  enableFollowupAug?: boolean;
  savedListDetailFeatureFlag?: boolean;
}

const ContactDealerMobileActions = ({
  userStoreLocationData,
  locale,
  isCustomerSupportEnabled = false,
  isLoggedIn = false,
  userHasShoppingLists = false,
  isCspUser = false,
  part,
  isInstantAccessUser,
  isDealerUser,
  isAssociateEquipmentToSavedList,
  myEquipmentList,
  selectedEquipmentIndex,
  isError,
  savedLists,
  isUpdatePDPCTAFeatureFlag,
  isPartTypeSoftware,
  isStickyCTAMobileFlag,
  enableFollowupAug,
  savedListDetailFeatureFlag = false
}: ContactDealerMobileActionsProps) => {
  const { address } = userStoreLocationData;

  const displayAddToListButton =
    !isUpdatePDPCTAFeatureFlag || !isPartTypeSoftware;

  return (
    <div className="d-md-none">
      {isStickyCTAMobileFlag && (
        <FixedContainer
          spacerClassName="d-md-none"
          containerClassName="d-md-none pt-2 mt-1"
        >
          <ContactDealerMobileDrawer
            locale={locale}
            dealerAddress={address}
            isCustomerSupportEnabled={isCustomerSupportEnabled}
            variant="contrast"
            size="md"
            className="ps-2 w-100"
          />

          {displayAddToListButton && enableFollowupAug && (
            <SavedListButton
              isLoggedIn={isLoggedIn}
              userHasShoppingLists={userHasShoppingLists}
              isCspUser={isCspUser}
              part={part}
              isInstantAccessUser={isInstantAccessUser}
              isDealerUser={isDealerUser}
              isAssociateEquipmentToSavedList={isAssociateEquipmentToSavedList}
              myEquipmentList={myEquipmentList}
              selectedEquipmentIndex={selectedEquipmentIndex}
              isError={isError}
              savedLists={savedLists}
              locale={locale}
              savedListDetailFeatureFlag={savedListDetailFeatureFlag}
              className="ps-2 w-100"
            />
          )}
        </FixedContainer>
      )}
    </div>
  );
};

export default ContactDealerMobileActions;
